import axiosInstance from "./AxiosInstance";

export function mappingImportFile(data) {
  return axiosInstance.post(`/mapping/importCSvOrExcel`, data);
}

export function createMappingStore(data) {
  return axiosInstance.post(`/mapping/store`, data);
}


 


 